<div class="alert-box">
  <div class="modal-header" style="background-color:  #659EC7;color: white;">
    <h4 class="modal-title" style="color: white;">{{data?.title || 'Info'}}</h4>
    <h4 aria-hidden="true" (click)="onCancel()" style="color:#fff">&times;</h4>
  </div>
  <div class="modal-body">
    @if (type != 'FORM') {
    <div [innerHTML]="data?.content"></div>
    }
    @if (type == 'FORM') {
    <info-view [modifyData]="data?.modifyData || {}" [mode]="mode" [sourceData]="data?.sourceData"
      [formData]="data?.formData"></info-view>
    }
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="onCancel()">{{data?.btn||'Ok'}}</button>
  </div>
</div>